import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./mdm_provider.js";
//#region src/mdm_provider_helper.ts
var mdm_provider_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(mdmProvider) {
	switch (mdmProvider) {
		case "simple-mdm": return "SimpleMDM";
		case "elo-view": return "EloView";
		case "esper": return "Esper";
		case "signage-os": return "SignageOS";
		case "chrome-os-flex": return "ChromeOSFlex";
		case "workspace-one": return "WorkspaceOne";
	}
}
//#endregion
export { mdm_provider_helper_exports, name };

//# sourceMappingURL=mdm_provider_helper.js.map